// Consent-Logik für Cookie-Banner und Meta Pixel

function getConsent() {
    try {
        return JSON.parse(localStorage.getItem('cookieConsent') || 'null');
    } catch (_) {
        return null;
    }
}

function setConsent(value) {
    localStorage.setItem('cookieConsent', JSON.stringify(value));
}

function showCookieBanner() {
    var banner = document.getElementById('cookie-banner');
    if (banner) banner.style.display = 'block';
}

function hideCookieBanner() {
    var banner = document.getElementById('cookie-banner');
    if (banner) banner.style.display = 'none';
}

function loadMetaPixel() {
    if (window.fbq) {
        return;
    }
    (function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0; t.src = v;
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '735974861290647');
    window.fbq('track', 'PageView');
}

function setupConsent() {
    var accept = document.getElementById('cookie-accept');
    var decline = document.getElementById('cookie-decline');
    if (accept) {
        accept.addEventListener('click', function () {
            setConsent(true);
            loadMetaPixel();
            hideCookieBanner();
        });
    }
    if (decline) {
        decline.addEventListener('click', function () {
            setConsent(false);
            hideCookieBanner();
        });
    }

    var manage = document.getElementById('cookie-manage');
    if (manage) {
        manage.addEventListener('click', function (ev) {
            ev.preventDefault();
            showCookieBanner();
        });
    }

    var existing = getConsent();
    if (existing === true) {
        loadMetaPixel();
        hideCookieBanner();
    } else if (existing === false) {
        hideCookieBanner();
    } else {
        showCookieBanner();
    }
}

export function initializeConsent() {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupConsent);
    } else {
        setupConsent();
    }
}


